var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarSearchBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63086 1L0.99928 8.55263L9.63086 16.1053",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSearchBack);
export default __webpack_public_path__ + "static/media/navbarSearchBack.36b94b29c2ea50a77a9311c233769cee.svg";
export { ForwardRef as ReactComponent };